import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FaqsService {

    constructor() { }

    getFAQs(): FAQInterface[] {
        return [
            {
                id: 1,
                question: "Can I use BrandQRCodes for free?",
                answer: `BrandQRCodes allows you to use its services for free but requires purchasing a plan in order to use the extra features. <a href="/auth/signup">Get started for free</a>`,
                categories: [
                    FAQCategories.PAYMENT,
                    FAQCategories.GENERAL,
                    FAQCategories.LANDING_PAGE,
                ]
            },
            {
                id: 2,
                question: "Can I customize my QR code?",
                answer: "Yes, you can customize your QR code to have specific colours, designs and even logos or other images.",
                categories: [
                    FAQCategories.PAYMENT,
                    FAQCategories.GENERAL,
                ]
            },
            {
                id: 3,
                question: "Can I restore my deleted QR code?",
                answer: "Unfortunately, once you delete your QR code, it cannot be restored",
                categories: [
                    FAQCategories.PAYMENT,
                    FAQCategories.GENERAL,
                ]
            },
            {
                id: 4,
                question: "Can the QR code be printed and used on physical platforms?",
                answer: "Yes, you can download and print your QR codes for whatever purpose.",
                categories: [
                    FAQCategories.PAYMENT,
                    FAQCategories.GENERAL,
                    FAQCategories.LANDING_PAGE,
                ]
            },
            {
                id: 5,
                question: "What is the difference between static and dynamic QR codes?",
                answer: "Static QR codes do not allow the change or update of the content within, while dynamic QR codes allow you to change the content occasionally as you deem fit.",
                categories: [
                    FAQCategories.PAYMENT,
                    FAQCategories.GENERAL,
                    FAQCategories.LANDING_PAGE,
                ]
            },
            {
                id: 6,
                question: "What are Pop-up forms?",
                answer: `Pop-up forms are created to appear above your dynamic QR pages.<br> <br>To gather visitor data, such as emails for email marketing campaigns, that’s when you use pop-up forms. Others reasons might include a call to action, such as filling out the form to sign up for an event. The majority of businesses opt to utilise them if the event they are promoting has a deadline. <a href="/pop-up-form">Learn more</a>`,
                categories: [
                    FAQCategories.POPUP,
                    FAQCategories.GENERAL,
                    FAQCategories.LANDING_PAGE,
                ]
            },
            {
                id: 7,
                question: "Is there a limit to leads generated from Pop-up forms?",
                answer: "There is currently no limit to leads generated from Pop-ups.",
                categories: [
                    FAQCategories.POPUP,
                    FAQCategories.GENERAL,
                ]
            },
            {
                id: 8,
                question: "Are Pop-up forms free?",
                answer: "You need a BrandQrCodes subscription to create pop-up forms, and you can get started by visiting our <a href='/pricing' class='text-danger' target='_blank'>pricing</a> page.",
                categories: [
                    FAQCategories.POPUP,
                    FAQCategories.GENERAL,
                ]
            },
            {
                id: 9,
                question: "How long does it take to build a Pop-up form?",
                answer: "Pop-up forms can be set up almost instantly. All you have to do is add your content to a pre-built form template, fill in the fields you want filled out, generate the Pop-up and attach it to any of your dynamic QR pages. No coding required.",
                categories: [
                    FAQCategories.POPUP,
                    FAQCategories.GENERAL,
                ]
            },
            {
                id: 10,
                question: "Why do I need a subscription?",
                answer: "You need a subscription for a good number of reasons, first on the list being the ability to generate dynamic QR Codes. Dynamic QR codes let you change the content of the QR code without having to generate a different QR Code. You also need a subscription to be able to attach pop-up forms to your dynamic QR Codes in order to generate potential business leads. You can learn more about pop-up forms <a href='pop-up-form' class='text-danger' target='_blank'>here</a>. <br><br> <p>You can do so much more with <a href='/' class='text-danger' target='_blank'>brandqrcodes.com</a> subscription, feel free to visit our <a href='/pricing' class='text-danger' target='_blank'>pricing</a> page for more.</p>",
                categories: [
                    FAQCategories.PAYMENT,
                    FAQCategories.REDEMPTION,
                ]
            },
            {
                id: 11,
                question: "When will my plan be activated?",
                answer: "Soon after you've signed in and used your voucher coupon! That simple.",
                categories: [
                    FAQCategories.REDEMPTION,
                ]
            },
            {
                id: 12,
                question: "Can I change my plan?",
                answer: "Yes, you can change your plan at any moment through the billing page in your dashboard or <a href='/contact-us?reason=2' class='text-danger' target='_blank'>contact us</a> if you need assistance updating your account.",
                categories: [
                    FAQCategories.PAYMENT,
                    FAQCategories.REDEMPTION,
                ]
            },
            {
                id: 13,
                question: "What payment options do you support?",
                answer: "You have the option of paying with a debit card, a credit card or a voucher code. ",
                categories: [
                    FAQCategories.PAYMENT,
                    FAQCategories.REDEMPTION,
                ]
            },
            {
                id: 14,
                question: "I have a voucher code, how do I redeem it?",
                answer: "You can redeem all voucher codes <a href='/redemption' class='text-danger' target='_blank'>here</a>",
                categories: [
                    FAQCategories.PAYMENT,
                ]
            },
            {
                id: 15,
                question: "How do I join the Referral Program?",
                answer: "Joining is easy! Simply <a href='/auth/signup' class='text-danger' target='_blank'>sign up</a> for our Referral Program, and you'll receive a unique referral link to start sharing.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 16,
                question: "Who can participate in the Referral Program?",
                answer: "Anyone can participate! Whether you're a customer, a partner, or just a fan of our products and services, you can join our Referral Program.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 17,
                question: "What is the commission rate?",
                answer: "You'll earn a generous <b class='text-danger'>20%</b> commission on the total sale amount for every purchase of all users that signed up through your referral link.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 18,
                question: "How long do I earn commissions on my referrals' purchases?",
                answer: "You'll earn a <b class='text-danger'>20%</b> commission on all their purchases for a full one year from the date of their initial sign up through your link.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 19,
                question: "How and when do I get paid?",
                answer: "Commissions are typically paid through PayPal when you request to cash out from your dashboard.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 20,
                question: "Are there any restrictions on promoting my referral link?",
                answer: "We encourage ethical and responsible promotion. Please avoid spamming, false advertising, or any other unethical practices. Violating these guidelines may result in the termination of your account. You are NOT allowed to advertise our goods or services on any website or online community that hosts pornographic or lewd material. We demand that all of our affiliates behave themselves ethically, professionally, and in strict accordance with all applicable rules and laws.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 21,
                question: "Is there a minimum payout amount?",
                answer: "Yes, there is typically a minimum payout amount to reduce transaction fees. The current minimum is <b>$50 USD</b>",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 22,
                question: "Can I track my referrals and earnings?",
                answer: "Absolutely! We provide a user-friendly dashboard where you can easily track your referrals, commissions, and earnings in real-time.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 23,
                question: "What if I have more questions or need assistance?",
                answer: `If you have any further questions or need assistance, our dedicated support team is ready to help you. Contact us through the <a href="/support" target="_blank">support portal</a>, and we'll get back to you promptly.`,
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 24,
                question: "Can I refer customers from outside my country?",
                answer: "Yes, you can refer customers from anywhere in the world! Our Referral Program is open to a global audience.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 25,
                question: "Is there a limit to how many people I can refer?",
                answer: "There's no limit! The more people you refer, the more you can earn. Sky's the limit when it comes to your earning potential.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 26,
                question: "Can I refer businesses as well as individuals?",
                answer: "Absolutely! We welcome both individual and business referrals. If they make a purchase through your link, you earn a commission.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 27,
                question: "Can I participate in other promotions or discounts while earning a commission?",
                answer: "Yes, you can still participate in other promotions and discounts as a customer or affiliate while earning your 20% commission.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 28,
                question: "Is PayPal the only payment method allowed?",
                answer: "Yes, currently, we exclusively use PayPal as the payment method for our Referral Program. This ensures secure and efficient transactions for all our affiliates.",
                categories: [
                    FAQCategories.REFERRAL,
                ]
            },
            {
                id: 29,
                question: "How does Memories work?",
                answer: `<ol>
                <li>Purchase your Memories QR code package.</li>
                <li>You'll immediately receive your QR Code and an activation code via email after completing your payment.</li>
                <li>Create an account and set up your gallery using the activation code. This allows you to customize the gallery and manage settings.</li>
                <li>Display the QR code at your event (posters, signs, invitations).</li>
                <li>Guests scan the code with their smartphones and upload photos/videos directly to the online gallery.</li>
                <li>Enjoy, download, and share the captured memories!</li>
                </ol>
                Check out <a href="/blog/20240513-wedding-photos-qr-codes" target="_blank">our step by step how-to guide</a> on getting started.
                `,
                categories: [
                    FAQCategories.ALACARTE_MEMORIES,
                ]
            },
            {
                id: 30,
                question: "Do guests need to download an app or sign up?",
                answer: `No! Guests simply scan the QR code with their phone's camera and upload photos directly through their web browser and no sign up required for guests.`,
                categories: [
                    FAQCategories.ALACARTE_MEMORIES,
                ]
            },
            {
                id: 31,
                question: "How do I control what gets uploaded?",
                answer: `You can remove pictures from your memories gallery via your dashboard.`,
                categories: [
                    FAQCategories.ALACARTE_MEMORIES,
                ]
            },
            {
                id: 32,
                question: "Can guests download photos?",
                answer: `Yes!  You have control over download permissions within your online gallery.`,
                categories: [
                    FAQCategories.ALACARTE_MEMORIES,
                ]
            },
            {
                id: 33,
                question: "How long is the online gallery accessible?",
                answer: `Gallery access duration varies depending on the chosen package.  Most packages offer access for several months, allowing ample time to relive and share your event memories.
                <br />Additionally, your gallery will always be live as long as you have a running subscription.`,
                categories: [
                    FAQCategories.ALACARTE_MEMORIES,
                ]
            },
            {
                id: 34,
                question: "Can I personalize the online gallery?",
                answer: `Absolutely!  We offer customisable gallery templates to add a personal touch to your event's online photo album.`,
                categories: [
                    FAQCategories.ALACARTE_MEMORIES,
                ]
            },
            {
                id: 35,
                question: "What if I have more questions or need assistance?",
                answer: `If you have any further questions or need assistance, our dedicated support team is ready to help you. Contact us through the <a href="/support" target="_blank">support portal</a>, and we'll get back to you promptly.`,
                categories: [
                    FAQCategories.ALACARTE_MEMORIES,
                ]
            },
        ]
    }
}

export interface FAQInterface {
    id: number;
    answer: string;
    question: string;
    categories: FAQCategories[];
}

export enum FAQCategories {
    POPUP = "POPUP",
    GENERAL = "GENERAL",
    PAYMENT = "PAYMENT",
    REFERRAL = "REFERRAL",
    REDEMPTION = "REDEMPTION",
    LANDING_PAGE = "LANDING_PAGE",
    ALACARTE_MEMORIES = "ALACARTE_MEMORIES",
}
